var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatagram3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Guidelines",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#26008A;stroke:#26008A;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.4,3H9.6C6,3,3,6,3,9.6v28.8C3,42,6,45,9.6,45h28.8c3.3,0,6-2.4,6.5-5.6C45,39.3,45,39.1,45,39v-0.1 c0-0.2,0-0.3,0-0.5V9.6C45,6,42,3,38.4,3z M40.7,36.3c-2.1-2.6-5.8-3-8.4-1c-0.4,0.3-0.7,0.6-1,1c-1,1-1.7,1.7-3.3,1.7 s-2.3-0.8-3.3-1.7C23.6,34.9,21.8,34,20,34s-3.6,0.9-4.7,2.3c-0.9,1-1.7,1.7-3.3,1.7s-2.3-0.8-3.3-1.7c-1-1.1-2.3-1.9-3.7-2.2v-5 c0.9,0.3,1.7,0.9,2.3,1.6C8.4,32.1,10.2,33,12,33s3.6-0.9,4.7-2.3c1-1,1.7-1.7,3.3-1.7s2.3,0.8,3.3,1.7c2.1,2.6,5.8,3,8.4,1 c0.4-0.3,0.7-0.6,1-1c1-1,1.7-1.7,3.3-1.7c1.3,0,2.5,0.7,3.3,1.7c1,1.1,2.3,1.9,3.7,2.2v5C42.1,37.6,41.3,37.1,40.7,36.3z  M22.1,24.1c0,0.5,0.5,0.9,1,0.9H43v5.9c-0.9-0.3-1.7-0.8-2.3-1.6c-2.1-2.6-5.8-3-8.4-1c-0.4,0.3-0.7,0.6-1,1c-1,1-1.7,1.7-3.3,1.7 s-2.3-0.8-3.3-1.7C23.6,27.9,21.8,27,20,27s-3.6,0.9-4.7,2.3c-0.9,1-1.7,1.7-3.3,1.7s-2.3-0.8-3.3-1.7c-1-1.1-2.3-1.9-3.7-2.2V25 h6.1c0.5,0,1-0.4,1-0.9c0.4-6.5,4.6-12.2,10.6-14.6C21.9,14.3,21.7,19.2,22.1,24.1z M9.6,5h28.8C40.9,5,43,7.1,43,9.6V23H24 c-0.3-4.9,0.1-9.9,1-14.7V8.2c0.1-0.5-0.3-1.1-0.8-1.2c-0.2,0-0.3,0-0.5,0l-0.6,0.2c-7,2.3-12,8.4-12.9,15.8H5V9.6 C5,7.1,7.1,5,9.6,5L9.6,5z M38.4,43H9.6C7.1,43,5,40.9,5,38.4v-2.2c0.9,0.3,1.7,0.9,2.3,1.6C8.4,39.1,10.2,40,12,40s3.6-0.9,4.7-2.3 c1-1,1.7-1.7,3.3-1.7s2.3,0.8,3.3,1.7c2.1,2.6,5.8,3,8.4,1c0.4-0.3,0.7-0.6,1-1c1-1,1.7-1.7,3.3-1.7c1.3,0,2.5,0.7,3.3,1.7 c0.9,1.1,2.1,1.8,3.4,2.2C42.1,41.7,40.4,43,38.4,43z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatagram3);
export default __webpack_public_path__ + "static/media/datagram_3.4e14355e114d57336a513c2485655610.svg";
export { ForwardRef as ReactComponent };